import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ThemePlaceholder from "@/pages/ThemePreview";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PeticionesList from "@/pages/PeticionesList";
import PeticionDetail from "@/pages/PeticionDetail";
import Clientes from "@/pages/Clientes";
import Espacios from "@/pages/Espacios";
import Materiales from "@/pages/Materiales";
import Proveedores from "@/pages/Proveedores";
import Cadenas from "@/pages/Cadenas";
import Usuarios from "@/pages/Usuarios";
import Supervision from "@/pages/Supervision";
import MisPendientes from "@/pages/MisPendientes";
import Perfil from "@/pages/Perfil";
import MisAcreditaciones from "@/pages/MisAcreditaciones";
import RutasList from "@/pages/RutasList";
import RutaCreate from "@/pages/RutaCreate";
import RutaDetail from "@/pages/RutaDetail";
import Vehiculos from "@/pages/Vehiculos";
import VehiculoDetail from "@/pages/VehiculoDetail";
import Mantenimiento from "@/pages/Mantenimiento";
import MiRuta from "@/pages/MiRuta";
import Reportes from "@/pages/Reportes";
import NoRealizadas from "@/pages/NoRealizadas";
import FotosPendientes from "@/pages/FotosPendientes";
import RepartoInteligente from "@/pages/RepartoInteligente";
import PortalMontaje from "@/pages/PortalMontaje";
import PortalFeedback from "@/pages/PortalFeedback";
import PortalParteMontaje from "@/pages/PortalParteMontaje";
import FeedbackDashboard from "@/pages/FeedbackDashboard";
import Tesoreria from "@/pages/Tesoreria";
import Productividad from "@/pages/Productividad";
import CalendarioRutas from "@/pages/CalendarioRutas";
import PortalCliente from "@/pages/PortalCliente";
import Colaboradores from "@/pages/Colaboradores";
import Estadisticas from "@/pages/Estadisticas";
import PendientesAprobacion from "@/pages/PendientesAprobacion";
import Gastos from "@/pages/Gastos";
import Leads from "@/pages/Leads";
import LeadsAnalytics from "@/pages/LeadsAnalytics";
import Diagnostico from "@/pages/Diagnostico";
import DocsInternos from "@/pages/DocsInternos";
import MigracionFlujoV2 from "@/pages/MigracionFlujoV2";
import MiProduccion from "@/pages/MiProduccion";
import CalculadoraPegatinas from "@/pages/CalculadoraPegatinas";
import TiendaPegatinas from "@/pages/TiendaPegatinas";
import TiendaPegatinasResultado from "@/pages/TiendaPegatinasResultado";
import TiendaSubirArte from "@/pages/TiendaSubirArte";
import AdminTiendaPegatinas from "@/pages/AdminTiendaPegatinas";
import MiLogistica from "@/pages/MiLogistica";
import PendientesMontar from "@/pages/PendientesMontar";
import CronogramaRutas from "@/pages/CronogramaRutas";
import AdminDiag from "@/pages/AdminDiag";
import AdminDiagStats from "@/pages/AdminDiagStats";
import AdminIntegraciones from "@/pages/AdminIntegraciones";
import AdminApiKeys from "@/pages/AdminApiKeys";
import AdminNotificaciones from "@/pages/AdminNotificaciones";
import AdminRoadmap from "@/pages/AdminRoadmap";
import AdminNormalizacion from "@/pages/AdminNormalizacion";
import HealthChecks from "@/pages/HealthChecks";
import AdminMigracionMarcoVinilo from "@/pages/AdminMigracionMarcoVinilo";
import AdminPortfolio from "@/pages/AdminPortfolio";
import AdminDiagPlanificacion from "@/pages/AdminDiagPlanificacion";
import AdminNormalizarEntregado from "@/pages/AdminNormalizarEntregado";
import AdminNormalizarEntregada from "@/pages/AdminNormalizarEntregada";
import AdminDiagLogistica from "@/pages/AdminDiagLogistica";
import AdminDiagWhatsApp from "@/pages/AdminDiagWhatsApp";
import MiDia from "@/pages/MiDia";
import CargaRuta from "@/pages/CargaRuta";
import AprobacionesRutas from "@/pages/AprobacionesRutas";
import ExpressMockup from "@/pages/Express";
import MontajesTabla from "@/pages/MontajesTabla";
import AdminImportar from "@/pages/AdminImportar";
import ScrollToTop from "@/components/ScrollToTop";
import Facturas from "@/pages/Facturas";
import Albaranes from "@/pages/Albaranes";
import CierresMensuales from "@/pages/CierresMensuales";
import Tareas from "@/pages/Tareas";
import Fichaje from "@/pages/Fichaje";
import FichajesAdmin from "@/pages/FichajesAdmin";
import RRHH from "@/pages/RRHH";
import RRHHAdmin from "@/pages/RRHHAdmin";
import CargaTrabajo from "@/pages/CargaTrabajo";
import FacturasExternos from "@/pages/FacturasExternos";
import GestoriaInmatic from "@/pages/GestoriaInmatic";
import SubClientes from "@/pages/SubClientes";
import InversionPersonal from "@/pages/InversionPersonal";
import WhatsApp from "@/pages/WhatsApp";
import Manuales from "@/pages/Manuales";
import Almacen from "@/pages/Almacen";
import BandejaIA from "@/pages/BandejaIA";
import InboundCorreo from "@/pages/InboundCorreo";
import Contrataciones from "@/pages/Contrataciones";
import AprendizajeParser from "@/pages/AprendizajeParser";
import ValidacionesPendientes from "@/pages/ValidacionesPendientes";
import PresupuestosList from "@/pages/PresupuestosList";
import PresupuestoDetail from "@/pages/PresupuestoDetail";
import CatalogoPrecios from "@/pages/CatalogoPrecios";
import Rentabilidad from "@/pages/Rentabilidad";
import Portfolio from "@/pages/Portfolio";
import FlotaMapa from "@/pages/FlotaMapa";
import FlotaDashboard from "@/pages/FlotaDashboard";
import Reportar from "@/pages/Reportar";
import PortalPresupuesto from "@/pages/PortalPresupuesto";
import Privacidad from "@/pages/Privacidad";
import { PortalSubLogin, PortalSubDashboard, PortalSubEspacio, PortalSubPartes, PortalSubNotifPrefs } from "@/pages/PortalSub";
import { Loader2 } from "lucide-react";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "sonner";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center text-zinc-400">
        <Loader2 className="w-6 h-6 animate-spin mr-2" /> Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

/** Redirige automáticamente a montadores a /mi-ruta cuando entran a la raíz */
function HomeRedirect({ children }) {
  const { user } = useAuth();
  const roles = user?.roles || [];
  const esSoloMontador = roles.length > 0 && roles.every((r) => r === "montador" || r === "montador_externo");
  if (esSoloMontador) return <Navigate to="/mi-ruta" replace />;
  return children;
}

/** Restringe rutas sólo a usuarios con rol 'admin'. No-admin → /dashboard. */
function AdminOnly({ children }) {
  const { user } = useAuth();
  const roles = user?.roles || [];
  if (!roles.includes("admin")) return <Navigate to="/" replace />;
  return children;
}

/** Permite acceso a admin o gestoria (asesoría laboral, lectura). */
function AdminOrGestoria({ children }) {
  const { user } = useAuth();
  const roles = user?.roles || [];
  if (!roles.includes("admin") && !roles.includes("gestoria")) return <Navigate to="/" replace />;
  return children;
}

/** Producción propia — Elia (diseño, produccion) o admin. */
function ProduccionGuard({ children }) {
  const { user } = useAuth();
  const roles = user?.roles || [];
  const ok = ["admin", "diseño", "diseno", "produccion"].some((r) => roles.includes(r));
  if (!ok) return <Navigate to="/" replace />;
  return children;
}

/** Logística entrada — Sara (logistica, administracion) o admin. */
function LogisticaGuard({ children }) {
  const { user } = useAuth();
  const roles = user?.roles || [];
  const ok = ["admin", "logistica", "administracion"].some((r) => roles.includes(r));
  if (!ok) return <Navigate to="/" replace />;
  return children;
}

/** Mi Logística (entrada): roles logística + cualquier usuario con permiso `logistica:recepcion` (p.ej. montadores). */
function LogisticaEntradaGuard({ children }) {
  const { user, hasPermission } = useAuth();
  const roles = user?.roles || [];
  const ok = ["admin", "logistica", "administracion"].some((r) => roles.includes(r)) || hasPermission("logistica:recepcion");
  if (!ok) return <Navigate to="/" replace />;
  return children;
}

/** Permite acceso a admin, gestoria, montador_externo. */
function FacturasExternosGuard({ children }) {  const { user } = useAuth();
  const roles = user?.roles || [];
  if (!["admin", "gestoria", "montador_externo"].some((r) => roles.includes(r))) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <ScrollToTop />
          <Toaster richColors position="top-right" closeButton expand />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<PortalCliente />} />
            <Route path="/portal/p/:pid" element={<PortalCliente />} />
            <Route path="/p/pres/:token" element={<PortalPresupuesto />} />
            <Route path="/p/montaje/:token" element={<PortalMontaje />} />
            <Route path="/p/feedback/:token" element={<PortalFeedback />} />
            <Route path="/p/parte/:token" element={<PortalParteMontaje />} />
            <Route path="/portal-sub/login" element={<PortalSubLogin />} />
            <Route path="/portal-sub/dashboard" element={<PortalSubDashboard />} />
            <Route path="/portal-sub/espacios/:id" element={<PortalSubEspacio />} />
            <Route path="/portal-sub/partes" element={<PortalSubPartes />} />
            <Route path="/portal-sub/notificaciones" element={<PortalSubNotifPrefs />} />
            <Route path="/obras" element={<Portfolio />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/privacy" element={<Privacidad />} />
            <Route path="/tienda/pegatinas" element={<TiendaPegatinas />} />
            <Route path="/tienda/pegatinas/mi-arte" element={<TiendaSubirArte />} />
            <Route path="/tienda/pegatinas/gracias" element={<TiendaPegatinasResultado ok={true} />} />
            <Route path="/tienda/pegatinas/error" element={<TiendaPegatinasResultado ok={false} />} />
            {/* Rutas REPORTAR (escaneo QR montadores). Requieren auth. */}
            <Route path="/r" element={<Protected><Reportar /></Protected>} />
            <Route path="/r/c/:cid" element={<Protected><Reportar /></Protected>} />
            <Route path="/r/p/:pid" element={<Protected><Reportar /></Protected>} />
            <Route path="/mi-ruta" element={<Protected><MiRuta /></Protected>} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route path="/" element={<HomeRedirect><Dashboard /></HomeRedirect>} />
              <Route path="/mis-pendientes" element={<MisPendientes />} />
              <Route path="/supervision" element={<Supervision />} />
              <Route path="/peticiones" element={<PeticionesList />} />
              <Route path="/peticiones/bandeja-ia" element={<BandejaIA />} />
              <Route path="/peticiones/correo-entrante" element={<InboundCorreo />} />
              <Route path="/contrataciones" element={<Contrataciones />} />
              <Route path="/admin/aprendizaje-parser" element={<AprendizajeParser />} />
              <Route path="/presupuestos" element={<PresupuestosList />} />
              <Route path="/presupuestos/:id" element={<PresupuestoDetail />} />
              <Route path="/catalogo-precios" element={<AdminOnly><CatalogoPrecios /></AdminOnly>} />
              <Route path="/rentabilidad" element={<AdminOnly><Rentabilidad /></AdminOnly>} />
              <Route path="/validaciones" element={<AdminOnly><ValidacionesPendientes /></AdminOnly>} />
              <Route path="/peticiones/:id" element={<PeticionDetail />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/espacios" element={<Espacios />} />
              <Route path="/materiales" element={<Materiales />} />
              <Route path="/proveedores" element={<Proveedores />} />
              <Route path="/cadenas" element={<Cadenas />} />
              <Route path="/usuarios" element={<AdminOnly><Usuarios /></AdminOnly>} />
              <Route path="/colaboradores" element={<Colaboradores />} />
              <Route path="/estadisticas" element={<AdminOnly><Estadisticas /></AdminOnly>} />
              <Route path="/aprobaciones-pendientes" element={<PendientesAprobacion />} />
              <Route path="/gastos" element={<Gastos />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/leads-analytics" element={<AdminOnly><LeadsAnalytics /></AdminOnly>} />
              <Route path="/diagnostico" element={<AdminOnly><Diagnostico /></AdminOnly>} />
              <Route path="/docs-internos" element={<AdminOnly><DocsInternos /></AdminOnly>} />
              <Route path="/admin/migracion-v2" element={<AdminOnly><MigracionFlujoV2 /></AdminOnly>} />
              <Route path="/produccion" element={<ProduccionGuard><MiProduccion /></ProduccionGuard>} />
              <Route path="/produccion/calculadora-pegatinas" element={<ProduccionGuard><CalculadoraPegatinas /></ProduccionGuard>} />
              <Route path="/admin/tienda-pegatinas" element={<AdminOnly><AdminTiendaPegatinas /></AdminOnly>} />
              <Route path="/logistica-entrada" element={<LogisticaEntradaGuard><MiLogistica /></LogisticaEntradaGuard>} />
              <Route path="/pendientes-montar" element={<LogisticaGuard><PendientesMontar /></LogisticaGuard>} />
              <Route path="/cronograma" element={<LogisticaGuard><CronogramaRutas /></LogisticaGuard>} />
              <Route path="/admin/diag" element={<AdminOnly><AdminDiag /></AdminOnly>} />
              <Route path="/admin/normalizacion" element={<AdminOnly><AdminNormalizacion /></AdminOnly>} />
              <Route path="/admin/diag/stats" element={<AdminOnly><AdminDiagStats /></AdminOnly>} />
              <Route path="/admin/integraciones" element={<AdminOnly><AdminIntegraciones /></AdminOnly>} />
              <Route path="/admin/api-keys" element={<AdminOnly><AdminApiKeys /></AdminOnly>} />
              <Route path="/admin/notificaciones" element={<AdminOnly><AdminNotificaciones /></AdminOnly>} />
              <Route path="/admin/roadmap" element={<AdminOnly><AdminRoadmap /></AdminOnly>} />
              <Route path="/admin/health-checks" element={<AdminOnly><HealthChecks /></AdminOnly>} />
              <Route path="/admin/marco-vinilo" element={<AdminOnly><AdminMigracionMarcoVinilo /></AdminOnly>} />
              <Route path="/admin/portfolio" element={<AdminOnly><AdminPortfolio /></AdminOnly>} />
              <Route path="/admin/diag-planificacion" element={<AdminOnly><AdminDiagPlanificacion /></AdminOnly>} />
              <Route path="/admin/normalizar-entregado" element={<AdminOnly><AdminNormalizarEntregado /></AdminOnly>} />
              <Route path="/admin/normalizar-entregada" element={<AdminOnly><AdminNormalizarEntregada /></AdminOnly>} />
              <Route path="/admin/diag-logistica" element={<AdminOnly><AdminDiagLogistica /></AdminOnly>} />
              <Route path="/admin/diag-whatsapp" element={<AdminOnly><AdminDiagWhatsApp /></AdminOnly>} />
              <Route path="/mi-dia" element={<MiDia />} />
              <Route path="/mi-ruta/:rid/cargar" element={<CargaRutaPage />} />
              <Route path="/admin/aprobaciones-rutas" element={<AprobacionesRutas />} />
              {/* Módulo Express — operaciones de mínima huella digital (acceso PIN, sin link en sidebar) */}
              <Route path="/express" element={<ExpressMockup />} />
              <Route path="/express-mockup" element={<ExpressMockup />} />
              <Route path="/montajes-tabla" element={<MontajesTabla />} />
              <Route path="/admin/importar" element={<AdminOnly><AdminImportar /></AdminOnly>} />
              <Route path="/facturas" element={<AdminOnly><Facturas /></AdminOnly>} />
              <Route path="/albaranes" element={<AdminOnly><Albaranes /></AdminOnly>} />
              <Route path="/cierres-mensuales" element={<AdminOnly><CierresMensuales /></AdminOnly>} />
              <Route path="/tareas" element={<Tareas />} />
              <Route path="/fichaje" element={<Fichaje />} />
              <Route path="/admin/fichajes" element={<AdminOrGestoria><FichajesAdmin /></AdminOrGestoria>} />
              <Route path="/rrhh" element={<RRHH />} />
              <Route path="/admin/rrhh" element={<AdminOrGestoria><RRHHAdmin /></AdminOrGestoria>} />
              <Route path="/admin/carga-trabajo" element={<AdminOrGestoria><CargaTrabajo /></AdminOrGestoria>} />
              <Route path="/facturas-externos" element={<FacturasExternosGuard><FacturasExternos /></FacturasExternosGuard>} />
              <Route path="/gestoria/inmatic" element={<FacturasExternosGuard><GestoriaInmatic /></FacturasExternosGuard>} />
              <Route path="/sub-clientes" element={<AdminOnly><SubClientes /></AdminOnly>} />
              <Route path="/inversion-personal" element={<AdminOrGestoria><InversionPersonal /></AdminOrGestoria>} />
              <Route path="/whatsapp" element={<WhatsApp />} />
              <Route path="/manuales" element={<Manuales />} />
              <Route path="/manuales/:slug" element={<Manuales />} />
              <Route path="/almacen" element={<Almacen />} />
              <Route path="/perfil" element={<Perfil />} />
              <Route path="/mis-acreditaciones" element={<MisAcreditaciones />} />
              <Route path="/rutas" element={<RutasList />} />
              <Route path="/rutas/nueva" element={<RutaCreate />} />
              <Route path="/rutas/:id" element={<RutaDetail />} />
              <Route path="/reparto-inteligente" element={<RepartoInteligente />} />
              <Route path="/calendario" element={<CalendarioRutas />} />
              <Route path="/vehiculos" element={<Vehiculos />} />
              <Route path="/vehiculos/:id" element={<VehiculoDetail />} />
              <Route path="/flota-mapa" element={<FlotaMapa />} />
              <Route path="/flota-dashboard" element={<FlotaDashboard />} />
              <Route path="/mantenimiento" element={<Mantenimiento />} />
              <Route path="/reportes" element={<Reportes />} />
              <Route path="/no-realizadas" element={<NoRealizadas />} />
              <Route path="/fotos-pendientes" element={<FotosPendientes />} />
              <Route path="/feedback" element={<FeedbackDashboard />} />
              <Route path="/tesoreria" element={<Tesoreria />} />
              <Route path="/productividad" element={<Productividad />} />
              <Route path="/preview/themes" element={<ThemePlaceholder />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;

// Wrapper para que CargaRuta funcione como Route con useParams
function CargaRutaPage() {
  const { rid } = useParams();
  const navigate = useNavigate();
  return <CargaRuta rutaId={rid} onBack={() => navigate("/mi-ruta")} />;
}
